(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prd-recommendation"] && !Shopify.designMode) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var section = document.querySelector(".product-recommendations");
  if (!section) return;

  var productId = section.dataset.productId;
  var limit = section.dataset.limit;

  // ✅ The section_id must match the section file name (without .liquid)
  var url = `/recommendations/products?section_id=prd-recommendation&limit=${limit}&product_id=${productId}`;

  var request = new XMLHttpRequest();
  request.open("GET", url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      // Find new product HTML from the reloaded section
      var newProducts = container.querySelector(".baestsellerour");
      var targetContainer = section.querySelector(".baestsellerour");

      if (newProducts && targetContainer) {
        targetContainer.innerHTML = newProducts.innerHTML;
      }
    }
  };
  request.send();
};

// Reload in theme editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "prd-recommendation") {
    loadProductRecommendationsIntoSection();
  }
});

// Initial load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
